<template v-if="ready">
    <v-app>
      <v-row>
        <v-col cols="12" md="5" class="p-30px d-none d-md-block">
          <v-card
            elevation="0"
            class="h-100 right-auth-card rounded-xl"
            :style="{
              backgroundImage: `url(${require('@/assets/img/dashboard-bg.svg')})`,
            }"
          >
            <v-row>
              <v-col cols="6" class="my-auto pa-0">
                <v-img
                  class="auth-logo"
                  max-width="90"
                  max-height="30"
                  src="https://cdn.kyano.app/img/kyano-logo-dark.svg"
                ></v-img>
              </v-col>
            </v-row>
            <div class="auth-card-content text-center">
              <v-img
                class="mb-5"
                :src="require('@/assets/img/login-auth-dashboard.png')"
              ></v-img>
            </div>
          </v-card>
        </v-col>
  
        <v-col cols="12" md="7" class="my-auto">
          <v-card elevation="0" class="pa-5 auth-card">
            <v-row class="py-10">
              <v-col cols="12">
                <v-img
                  class="auth-logo d-md-none d-block"
                  max-width="90"
                  max-height="30"
                  src="https://cdn.kyano.app/img/kyano-logo-dark.svg"
                ></v-img>
                <div class="gradient-text">
                  404 page not found
                </div>
                <h1 class="mb-0 h2 text-secondary">
                  We couldn't find this page. Please go back to your home page.
                </h1>
              </v-col>
  
              <v-col cols="12">
                <v-btn
                  elevation="0"
                  class="btn btn-primary text-white"
                  large
                  block
                  @click="submit"
                  color="var(--primary)"
                >
                  Back to home
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-app>
  </template>
  
  <script>
  import { computed } from 'vue';
  import { useMainStore } from '@/stores/store';
  
  export default {
    setup() {
      const mainStore = useMainStore();
  
      // Compute the workspace ID
      const workspace_id = computed(() => {
        const selectedWorkspace = mainStore.user.workspaces.find(
          (workspace) => workspace.id === mainStore.getSelectedWorkspaceId
        );
        return selectedWorkspace ? selectedWorkspace.id : "";
      });
  
      return {
        workspace_id,
      };
    },
    data() {
      return {
        ready: true,
      };
    },
    methods: {
      submit() {
        // Ensure workspace_id is properly referenced here
        this.$router.push(`/${this.workspace_id}`);
      },
    },
  };
  </script>
  